// MB-I18N-2A — admin FR (extrait de LanguageContext, valeurs inchangées).
export default {
  "os.admin.nav.group.communication": "Communication",
  "os.admin.nav.news": "Actus",
  "os.admin.nav.group.purchasing": "Achats",
  "os.admin.nav.supplier_invoices": "Factures fournisseurs",
  "os.admin.supinv.title": "Factures fournisseurs",
  "os.admin.supinv.subtitle": "Factures électroniques reçues pour votre boutique.",
  "os.admin.supinv.refresh": "Actualiser",
  "os.admin.supinv.search_placeholder": "Fournisseur ou numéro…",
  "os.admin.supinv.filter_all": "Tous",
  "os.admin.supinv.filter_to_process": "À traiter",
  "os.admin.supinv.filter_accepted": "Acceptées",
  "os.admin.supinv.filter_refused": "Refusées",
  "os.admin.supinv.filter_error": "En erreur",
  "os.admin.supinv.filter_paid": "Payées",
  "os.admin.supinv.filter_unpaid": "Non payées",
  "os.admin.supinv.col_number": "Numéro",
  "os.admin.supinv.col_issue": "Émission",
  "os.admin.supinv.col_due": "Échéance",
  "os.admin.supinv.type_invoice": "Facture",
  "os.admin.supinv.type_credit": "Avoir",
  "os.admin.supinv.linked": "Fournisseur rattaché",
  "os.admin.supinv.unlinked": "Non rattaché",
  "os.admin.supinv.unknown_supplier": "Fournisseur inconnu",
  "os.admin.supinv.tech_received": "Reçue",
  "os.admin.supinv.tech_validated": "Validée",
  "os.admin.supinv.tech_waiting_document": "En attente de document",
  "os.admin.supinv.tech_error": "Erreur",
  "os.admin.supinv.tech_quarantined": "Quarantaine",
  "os.admin.supinv.life_available": "Disponible",
  "os.admin.supinv.life_accepted": "Acceptée",
  "os.admin.supinv.life_refused": "Refusée",
  "os.admin.supinv.life_disputed": "En litige",
  "os.admin.supinv.life_archived": "Archivée",
  "os.admin.supinv.pay_unpaid": "Non payée",
  "os.admin.supinv.pay_paid": "Payée",
  "os.admin.supinv.alert_quarantine": "Quarantaine",
  "os.admin.supinv.alert_error": "Erreur technique",
  "os.admin.supinv.alert_invalid": "Document invalide",
  "os.admin.supinv.view_detail": "Voir le détail",
  "os.admin.supinv.detail_soon": "La page détail arrive bientôt.",
  "os.admin.supinv.empty_title": "Aucune facture fournisseur reçue pour le moment.",
  "os.admin.supinv.empty_desc": "Les factures électroniques reçues via votre future Plateforme Agréée apparaîtront ici.",
  "os.admin.supinv.no_results": "Aucun résultat.",
  "os.admin.supinv.error_title": "Impossible de charger les factures.",
  "os.admin.supinv.error_desc": "Veuillez réessayer.",
  "os.admin.supinv.detail_back": "Retour à la liste",
  "os.admin.supinv.detail_ttc": "Montant TTC",
  "os.admin.supinv.detail_delivery": "Livraison",
  "os.admin.supinv.detail_currency": "Devise",
  "os.admin.supinv.detail_ht": "Montant HT",
  "os.admin.supinv.detail_tva": "TVA",
  "os.admin.supinv.detail_statuses": "Statuts",
  "os.admin.supinv.detail_alerts": "Alertes",
  "os.admin.supinv.detail_alert_misaddressed": "Facture potentiellement mal adressée",
  "os.admin.supinv.detail_supplier_identity": "Identité fournisseur",
  "os.admin.supinv.detail_legal_name": "Raison sociale",
  "os.admin.supinv.detail_vat": "N° TVA",
  "os.admin.supinv.detail_country": "Pays",
  "os.admin.supinv.detail_buyer": "Acheteur",
  "os.admin.supinv.detail_establishment": "Établissement",
  "os.admin.supinv.detail_lines": "Lignes",
  "os.admin.supinv.detail_no_lines": "Aucune ligne disponible.",
  "os.admin.supinv.detail_col_desc": "Désignation",
  "os.admin.supinv.detail_col_qty": "Qté",
  "os.admin.supinv.detail_col_pu": "PU HT",
  "os.admin.supinv.detail_col_vat": "TVA",
  "os.admin.supinv.detail_col_ht": "Total HT",
  "os.admin.supinv.detail_col_ttc": "Total TTC",
  "os.admin.supinv.detail_vat_breakdown": "Ventilation TVA",
  "os.admin.supinv.detail_no_vat": "Aucune ventilation TVA disponible.",
  "os.admin.supinv.detail_documents": "Documents",
  "os.admin.supinv.detail_doc_pdf": "Document PDF",
  "os.admin.supinv.detail_doc_structured": "Document structuré",
  "os.admin.supinv.detail_doc_payload": "Payload original",
  "os.admin.supinv.detail_doc_available": "Disponible",
  "os.admin.supinv.detail_doc_unavailable": "Indisponible",
  "os.admin.supinv.detail_timeline": "Historique",
  "os.admin.supinv.detail_no_events": "Aucun événement.",
  "os.admin.supinv.detail_loading": "Chargement…",
  "os.admin.supinv.detail_evt_attached": "Fournisseur rattaché",
  "os.admin.supinv.detail_evt_reattached": "Fournisseur modifié",
  "os.admin.news.title": "Actualités",
  "os.admin.news.subtitle_before": "Communiquez avec les clients de ",
  "os.admin.news.add_btn": "Nouvelle actu",
  "os.admin.news.no_shop": "Sélectionnez une boutique pour gérer ses actualités.",
  "os.admin.news.empty_title": "Aucune actualité publiée pour le moment.",
  "os.admin.news.empty_desc": "Annoncez vos nouveautés, promotions et événements directement à vos clients.",
  "os.admin.news.empty_cta": "Créer une actualité",
  "os.admin.news.toast_load_error": "Impossible de charger les actualités",
  "os.admin.news.toast_created": "Actualité créée",
  "os.admin.news.toast_updated": "Actualité mise à jour",
  "os.admin.news.toast_archived": "Actualité archivée",
  "os.admin.news.toast_save_error": "Échec de l’enregistrement",
  "os.admin.news.toast_archive_error": "Échec de l’archivage",
  "os.admin.news.toast_title_required": "Le titre est requis",
  "os.admin.news.toast_dates_invalid": "La date de fin doit être postérieure à la date de début",
  "os.admin.news.dialog_new_title": "Nouvelle actualité",
  "os.admin.news.dialog_edit_title": "Modifier l’actualité",
  "os.admin.news.field_title": "Titre",
  "os.admin.news.field_title_ph": "Ex : Nouveau Latte Pistache",
  "os.admin.news.field_description": "Description",
  "os.admin.news.field_description_ph": "Décrivez votre actualité…",
  "os.admin.news.field_category": "Catégorie",
  "os.admin.news.field_start": "Date de début",
  "os.admin.news.field_end": "Date de fin",
  "os.admin.news.field_end_hint": "Laissez vide pour une actu sans expiration",
  "os.admin.news.field_status": "Statut",
  "os.admin.news.status_draft": "Brouillon",
  "os.admin.news.status_published": "Publié",
  "os.admin.news.archive_title": "Archiver",
  "os.admin.news.period_range": "Du {start} au {end}",
  "os.admin.news.period_from": "À partir du {start}",
  "os.admin.news.state_draft": "Brouillon",
  "os.admin.news.state_scheduled": "Programmé",
  "os.admin.news.state_published": "Publié",
  "os.admin.news.state_expired": "Expiré",
  "os.admin.news.cat_information": "Information",
  "os.admin.news.cat_promotion": "Promotion",
  "os.admin.news.cat_nouveau_produit": "Nouveau produit",
  "os.admin.news.cat_fidelite": "Fidélité",
  "os.admin.news.cat_horaires": "Horaires",
  "os.admin.news.cat_evenement": "Événement",
  "os.admin.news.cat_recette": "Recette",
  "os.admin.news.ai_open_btn": "Générer avec l’IA",
  "os.admin.news.ai_keywords_label": "Consigne ou mots-clés",
  "os.admin.news.ai_keywords_ph": "Ex : Brunch dimanche, formule à 19 €, réservation conseillée",
  "os.admin.news.ai_tone_label": "Ton",
  "os.admin.news.ai_language_label": "Langue",
  "os.admin.news.ai_length_label": "Longueur",
  "os.admin.news.ai_language_fr": "Français",
  "os.admin.news.ai_language_en": "Anglais",
  "os.admin.news.ai_tone_professionnel": "Professionnel",
  "os.admin.news.ai_tone_chaleureux": "Chaleureux",
  "os.admin.news.ai_tone_dynamique": "Dynamique",
  "os.admin.news.ai_tone_premium": "Premium",
  "os.admin.news.ai_tone_convivial": "Convivial",
  "os.admin.news.ai_length_court": "Court",
  "os.admin.news.ai_length_moyen": "Moyen",
  "os.admin.news.ai_length_long": "Long",
  "os.admin.news.ai_generating": "Génération en cours…",
  "os.admin.news.ai_generate_btn": "Générer le texte",
  "os.admin.news.ai_quota_other": "{count} générations restantes aujourd’hui",
  "os.admin.news.ai_quota_one": "1 génération restante aujourd’hui",
  "os.admin.news.ai_quota_zero": "Aucune génération restante aujourd’hui",
  "os.admin.news.ai_toast_quota_exceeded": "Quota atteint",
  "os.admin.news.ai_toast_forbidden": "Génération réservée aux propriétaires et responsables",
  "os.admin.news.ai_toast_generic_error": "Erreur de génération",
  "os.admin.news.ai_toast_keywords_required": "La consigne ou les mots-clés sont requis",
  "os.admin.news.image_label": "Image (optionnelle)",
  "os.admin.news.image_add": "Ajouter",
  "os.admin.news.image_replace": "Remplacer",
  "os.admin.news.image_hint": "JPG, PNG ou WebP · 5 Mo max · recadrée en carré",
  "os.admin.common.save": "Enregistrer",
  "os.admin.common.cancel": "Annuler",
  "os.admin.common.edit": "Modifier",
  "os.admin.common.delete": "Supprimer",
  "os.admin.common.retry": "Réessayer",
  "os.admin.common.loading": "Chargement…",
  "os.admin.common.empty": "Aucun élément",
  "os.admin.common.search": "Rechercher",
  "os.admin.common.filter": "Filtrer",
  "os.admin.common.close": "Fermer",
  "os.admin.common.confirm": "Confirmer",
  "os.admin.status.pending": "En attente",
  "os.admin.status.preparing": "En préparation",
  "os.admin.status.ready": "Prêt",
  "os.admin.status.completed": "Terminé",
  "os.admin.status.cancelled": "Annulé",
  "os.admin.toasts.error": "Une erreur est survenue",
  "os.admin.toasts.success": "Opération réussie",
  "os.admin.toasts.update_error": "Erreur de mise à jour",
  "os.admin.orders.filter_active": "Actives",
  "os.admin.orders.filter_pending": "En attente",
  "os.admin.orders.filter_preparing": "En préparation",
  "os.admin.orders.filter_ready": "Prêtes",
  "os.admin.orders.filter_completed": "Terminées",
  "os.admin.orders.empty": "Aucune commande",
  "os.admin.orders.pay_wallet": "Portefeuille",
  "os.admin.orders.pay_cash": "Espèces",
  "os.admin.orders.more_items": "+{count} autres articles",
  "os.admin.orders.total_ht": "Total HT",
  "os.admin.orders.vat": "TVA ({rate} %)",
  "os.admin.orders.total_ttc": "Total TTC",
  "os.admin.orders.total": "Total",
  "os.admin.orders.prep_time": "Temps: {min} min",
  "os.admin.orders.mark_ready": "Marquer Prêt",
  "os.admin.orders.complete": "Terminer",
  "os.admin.orders.toast_updated": "Commande mise à jour: {status}",
  "os.admin.products.subtab_products": "Produits",
  "os.admin.products.subtab_recipes": "Recettes",
  "os.admin.products.search_placeholder": "Rechercher un produit...",
  "os.admin.products.category_placeholder": "Catégorie",
  "os.admin.products.all_categories": "Toutes catégories",
  "os.admin.products.library_catalog": "Catalogue SUPERKAWA",
  "os.admin.products.new": "Nouveau",
  "os.admin.products.saving_prices": "Enregistrement…",
  "os.admin.products.save_prices": "Enregistrer les prix ({count})",
  "os.admin.products.recommended_count": "{count} / 70 produits recommandés",
  "os.admin.products.concise_hint": " · une carte concise se vend mieux",
  "os.admin.products.col_product": "Produit",
  "os.admin.products.col_category": "Catégorie",
  "os.admin.products.col_price": "Prix",
  "os.admin.products.col_status": "Statut",
  "os.admin.products.col_actions": "Actions",
  "os.admin.products.reorder_start": "Réorganiser le Plan de Travail",
  "os.admin.products.reorder_done": "Terminer",
  "os.admin.products.reorder_hint": "Utilisez les flèches ↑ / ↓ pour ordonner vos produits dans chaque catégorie. Le POS reprend cet ordre immédiatement.",
  "os.admin.products.reorder_error": "Échec de la réorganisation. Veuillez réessayer.",
  "os.admin.products.move_up": "Monter",
  "os.admin.products.move_down": "Descendre",
  "os.admin.products.priority_add": "Marquer comme Prioritaire",
  "os.admin.products.priority_remove": "Retirer des Prioritaires",
  "os.admin.products.priority_on": "Ajouté aux Prioritaires",
  "os.admin.products.priority_off": "Retiré des Prioritaires",
  "os.admin.products.priority_error": "Échec de la mise à jour. Veuillez réessayer.",
  "os.admin.products.status_draft": "Brouillon",
  "os.admin.products.status_active": "Actif",
  "os.admin.products.status_inactive": "Inactif",
  "os.admin.products.empty": "Aucun produit trouvé",
  "os.admin.products.dialog_edit_title": "Modifier le produit",
  "os.admin.products.dialog_new_title": "Nouveau produit",
  "os.admin.products.field_name": "Nom",
  "os.admin.products.field_description": "Description",
  "os.admin.products.field_category": "Catégorie",
  "os.admin.products.field_price_s": "Prix — Taille S ({currency})",
  "os.admin.products.field_price_l": "Prix — Taille L (optionnel) ({currency})",
  "os.admin.products.price_l_hint": "Laisser vide pour désactiver la taille L",
  "os.admin.products.field_tax_category": "Catégorie fiscale (TVA)",
  "os.admin.products.tax_category_hint": "France uniquement — détermine le taux de TVA appliqué (laisser « Non définie » pour le comportement par défaut).",
  "os.admin.products.tax_cat_none": "Non définie",
  "os.admin.products.tax_cat_food": "Aliment",
  "os.admin.products.tax_cat_soft_drink": "Boisson non alcoolisée",
  "os.admin.products.tax_cat_grocery": "Aliment à conserver",
  "os.admin.products.tax_cat_alcohol": "Alcool",
  "os.admin.products.field_available": "Disponible à la vente",
  "os.admin.products.placeholder_name": "Ex: Latte Noisette",
  "os.admin.products.placeholder_description": "Description courte...",
  "os.admin.products.create": "Créer",
  "os.admin.products.confirm_disable": "Désactiver ce produit ?",
  "os.admin.products.toast_name_price_required": "Nom et prix requis",
  "os.admin.products.toast_no_shop": "Aucune boutique sélectionnée — impossible de créer le produit",
  "os.admin.products.toast_updated": "Produit mis à jour",
  "os.admin.products.toast_created": "Produit créé",
  "os.admin.products.toast_create_error": "Erreur de création",
  "os.admin.products.toast_disabled": "Produit désactivé",
  "os.admin.products.toast_delete_error": "Erreur de suppression",
  "os.admin.products.toast_prices_updated": "{count} prix mis à jour",
  "os.admin.products.toast_prices_error": "Erreur lors de l'enregistrement des prix",
  "os.admin.products.image_label": "Photo du produit",
  "os.admin.products.image_alt": "Aperçu",
  "os.admin.products.image_replace": "Remplacer",
  "os.admin.products.image_add": "Ajouter une photo",
  "os.admin.products.image_hint": "Recadrage carré automatique · JPG/PNG/WebP · 5 Mo max",
  "os.admin.products.image_toast_format": "Format non supporté (JPG, PNG ou WebP)",
  "os.admin.products.image_toast_too_large": "Image trop lourde (5 Mo max)",
  "os.admin.products.image_toast_added": "Photo ajoutée",
  "os.admin.products.image_toast_upload_error": "Échec de l'upload",
  "os.admin.nav.group.pilotage": "Pilotage",
  "os.admin.nav.group.catalogue": "Catalogue",
  "os.admin.nav.group.stock": "Stock",
  "os.admin.nav.group.cost": "Coût matière",
  "os.admin.nav.group.loyalty": "Fidélité",
  "os.admin.nav.group.team": "Équipe",
  "os.admin.nav.group.settings": "Paramètres",
  "os.admin.nav.dashboard": "Tableau de bord",
  "os.admin.nav.orders": "Commandes",
  "os.admin.nav.stats": "Statistiques",
  "os.admin.nav.menu": "Menu & Recettes",
  "os.admin.nav.stock": "Stock",
  "os.admin.nav.ingredients": "Ingrédients",
  "os.admin.nav.material_cost": "Coût matière",
  "os.admin.nav.margins": "Marges",
  "os.admin.nav.inventory": "Inventaire matière",
  "os.admin.nav.rewards": "Récompenses",
  "os.admin.nav.reviews": "Avis",
  "os.admin.reviews.title": "Avis clients",
  "os.admin.reviews.summary_average": "Note moyenne",
  "os.admin.reviews.summary_total": "Total d'avis",
  "os.admin.reviews.summary_published": "Publiés",
  "os.admin.reviews.summary_hidden": "Masqués",
  "os.admin.reviews.distribution": "Répartition des notes",
  "os.admin.reviews.list_label": "Avis reçus",
  "os.admin.reviews.empty": "Aucun avis pour le moment.",
  "os.admin.reviews.no_shop": "Sélectionnez une boutique pour voir ses avis.",
  "os.admin.reviews.status_published": "Publié",
  "os.admin.reviews.status_hidden": "Masqué",
  "os.admin.reviews.client_ref": "Client",
  "os.admin.reviews.merchant_reply": "Réponse du commerçant",
  "os.admin.reviews.reply": "Répondre",
  "os.admin.reviews.edit_reply": "Modifier la réponse",
  "os.admin.reviews.reply_title": "Répondre à l'avis",
  "os.admin.reviews.reply_placeholder": "Votre réponse (max 1000 caractères)",
  "os.admin.reviews.reply_empty": "La réponse ne peut pas être vide.",
  "os.admin.reviews.send": "Envoyer",
  "os.admin.reviews.hide": "Masquer",
  "os.admin.reviews.show": "Afficher",
  "os.admin.reviews.toast_load_error": "Erreur lors du chargement des avis.",
  "os.admin.reviews.toast_reply_ok": "Réponse enregistrée.",
  "os.admin.reviews.toast_reply_error": "Erreur lors de l'envoi de la réponse.",
  "os.admin.reviews.toast_toggle_ok": "Visibilité mise à jour.",
  "os.admin.reviews.toast_toggle_error": "Erreur lors de la mise à jour de la visibilité.",
  "os.admin.nav.team": "Équipe",
  "os.admin.nav.shop": "Boutique",
  "os.admin.nav.closures": "Clôtures Z",
  "os.admin.nav.compliance": "Conformité fiscale",
  "os.admin.nav.audit": "Audit Log",
  "os.admin.common.no_shop_selected": "Aucune boutique sélectionnée.",
  "os.admin.shop.create_title": "Créer une boutique",
  "os.admin.shop.create_subtitle": "La devise est dérivée automatiquement du pays. Vous serez rattaché comme propriétaire.",
  "os.admin.shop.field_name": "Nom de la boutique",
  "os.admin.shop.field_address": "Adresse",
  "os.admin.shop.field_country": "Pays",
  "os.admin.shop.field_timezone": "Fuseau horaire",
  "os.admin.shop.timezone_placeholder": "Sélectionner un fuseau",
  "os.admin.shop.timezone_hint": "Heure locale de l'établissement (utilisée pour les analytics)",
  "os.admin.shop.timezone_not_configured": "Fuseau horaire non configuré",
  "os.admin.shop.timezone_suggestion": "Suggestion pour ce pays :",
  "os.admin.shop.toast_timezone_invalid": "Fuseau horaire invalide",
  "os.admin.shop.placeholder_name": "Ex: SUPERKAWA Oran",
  "os.admin.shop.placeholder_address": "Ex: Front de mer, Oran",
  "os.admin.shop.create_btn": "Créer la boutique",
  "os.admin.shop.edit_title": "Modifier la boutique active",
  "os.admin.shop.active_label": "Boutique active",
  "os.admin.shop.active_hint": "Visible et sélectionnable dans le POS / OS",
  "os.admin.shop.save_changes_btn": "Enregistrer les modifications",
  "os.admin.shop.appearance_title": "Apparence de ma boutique",
  "os.admin.shop.appearance_subtitle": "Personnalisez la vitrine que vos clients découvrent sur SUPERKAWA.",
  "os.admin.shop.appearance_toast_format": "Format non supporté (JPG, PNG ou WebP uniquement)",
  "os.admin.shop.appearance_toast_too_large": "Image trop lourde (5 Mo maximum)",
  "os.admin.shop.appearance_toast_upload_error": "Erreur lors de l'envoi de l'image",
  "os.admin.shop.appearance_toast_update_error": "Erreur lors de la mise à jour",
  "os.admin.shop.appearance_toast_description_saved": "Description enregistrée",
  "os.admin.shop.appearance_cover_label": "Photo de couverture",
  "os.admin.shop.appearance_cover_btn": "Modifier la couverture",
  "os.admin.shop.appearance_cover_hint": "Choisissez de préférence une photo horizontale de votre établissement.",
  "os.admin.shop.appearance_logo_label": "Logo",
  "os.admin.shop.appearance_logo_add": "Ajouter un logo",
  "os.admin.shop.appearance_logo_replace": "Modifier le logo",
  "os.admin.shop.appearance_logo_hint": "Le logo est facultatif. Sans logo, SUPERKAWA affichera les initiales de votre boutique.",
  "os.admin.shop.appearance_description_label": "Description",
  "os.admin.shop.appearance_description_hint": "Présentez en quelques mots votre concept, votre ambiance ou votre spécialité.",
  "os.admin.shop.appearance_description_save_btn": "Enregistrer la description",
  "os.admin.shop.appearance_gallery_label": "Galerie",
  "os.admin.shop.appearance_gallery_add": "Ajouter une photo",
  "os.admin.shop.appearance_gallery_replace": "Remplacer la photo",
  "os.admin.shop.appearance_gallery_move_left": "Déplacer vers la gauche",
  "os.admin.shop.appearance_gallery_move_right": "Déplacer vers la droite",
  "os.admin.shop.appearance_gallery_hint": "Ajoutez jusqu'à 5 photos de votre établissement.",
  "os.admin.shop.appearance_gallery_subhint": "JPG, PNG ou WebP · 5 Mo maximum par photo. Les photos sont automatiquement optimisées.",
  "os.admin.shop.seller_title": "Identité fiscale vendeur",
  "os.admin.shop.seller_subtitle": "Informations légales de l'établissement utilisées pour la future facturation B2B. Tous les champs sont optionnels.",
  "os.admin.shop.seller_legal_name": "Raison sociale",
  "os.admin.shop.seller_registration_number": "Numéro d'immatriculation",
  "os.admin.shop.seller_tax_identifier": "Identifiant fiscal",
  "os.admin.shop.seller_vat_identifier": "TVA intracommunautaire",
  "os.admin.shop.seller_address_section": "Adresse de facturation",
  "os.admin.shop.seller_street": "Rue",
  "os.admin.shop.seller_postal_code": "Code postal",
  "os.admin.shop.seller_city": "Ville",
  "os.admin.shop.seller_country": "Pays",
  "os.admin.shop.seller_contact_section": "Contact",
  "os.admin.shop.seller_contact_name": "Nom du contact",
  "os.admin.shop.seller_contact_email": "Email",
  "os.admin.shop.seller_contact_phone": "Téléphone",
  "os.admin.shop.seller_save_btn": "Enregistrer l'identité fiscale",
  "os.admin.shop.seller_saved": "Identité fiscale vendeur enregistrée",
  "os.admin.shop.seller_save_error": "Erreur lors de l'enregistrement de l'identité fiscale",
  "os.admin.shop.pause_title": "Pause du service",
  "os.admin.shop.pause_subtitle": "Configurez le message affiché aux clients lorsque la pause est activée depuis le POS.",
  "os.admin.shop.pause_state": "État actuel :",
  "os.admin.shop.pause_state_paused": "En pause",
  "os.admin.shop.pause_state_active": "Service actif",
  "os.admin.shop.pause_managed_pos": "Géré depuis le POS",
  "os.admin.shop.pause_type": "Type de pause",
  "os.admin.shop.pause_simple": "Pause simple",
  "os.admin.shop.pause_salat": "Pause salât",
  "os.admin.shop.pause_custom": "Message personnalisé",
  "os.admin.shop.pause_custom_placeholder": "Ex: Inventaire en cours, retour à 14h",
  "os.admin.operating.title": "Statut opérationnel",
  "os.admin.operating.subtitle": "Contrôlez la disponibilité de votre établissement. Une pause ou fermeture bloque les nouvelles opérations mais n'affecte pas les commandes en cours.",
  "os.admin.operating.current": "État actuel :",
  "os.admin.operating.reopen": "Rouvrir",
  "os.admin.operating.prayer_toggle": "Pause prière",
  "os.admin.operating.prayer_hint": "Facultatif. Active le motif « Prière » pour cette boutique uniquement.",
  "os.admin.operating.status_label": "Statut",
  "os.admin.operating.status_OPEN": "Ouvert",
  "os.admin.operating.status_PAUSED": "En pause",
  "os.admin.operating.status_CLOSED": "Fermé",
  "os.admin.operating.status_MAINTENANCE": "Maintenance",
  "os.admin.operating.status_SUSPENDED": "Suspendu",
  "os.admin.operating.reason_label": "Motif",
  "os.admin.operating.reason_none": "Aucun motif",
  "os.admin.operating.reason_BREAK": "Pause",
  "os.admin.operating.reason_LUNCH": "Déjeuner",
  "os.admin.operating.reason_PRAYER": "Prière",
  "os.admin.operating.reason_STAFF_SHORTAGE": "Manque de personnel",
  "os.admin.operating.reason_TECHNICAL": "Problème technique",
  "os.admin.operating.reason_INVENTORY": "Inventaire",
  "os.admin.operating.reason_OTHER": "Autre",
  "os.admin.operating.message_label": "Message public (facultatif)",
  "os.admin.operating.message_placeholder": "Ex: Nous revenons à 14h",
  "os.admin.operating.until_label": "Reprise prévue (facultatif)",
  "os.admin.operating.saved": "Statut opérationnel mis à jour",
  "os.admin.operating.reopened": "Établissement rouvert",
  "os.admin.operating.load_error": "Impossible de charger le statut opérationnel",
  "os.admin.operating.save_error": "Erreur lors de la mise à jour du statut",
  "os.admin.shop.toast_name_address_required": "Nom et adresse sont requis",
  "os.admin.shop.toast_country_not_supported": "Ce pays n'est pas encore activé. Contactez SUPERKAWA pour l'activer.",
  "os.admin.shop.toast_store_created": "Boutique « {name} » créée en période d'essai.",
  "os.admin.shop.toast_store_create_error": "Erreur lors de la création de la boutique",
  "os.admin.shop.toast_store_updated": "Boutique mise à jour",
  "os.admin.shop.toast_store_update_error": "Erreur lors de la mise à jour",
  "os.admin.shop.toast_pause_load_error": "Impossible de charger la configuration pause",
  "os.admin.shop.toast_pause_saved": "Configuration pause enregistrée",
  "os.admin.shop.toast_save_error": "Erreur lors de l'enregistrement",
  "os.admin.shop.wl_title": "Wallet & Fidélité",
  "os.admin.shop.wl_subtitle_before": "Configurez le wallet et la fidélité de cette boutique. La devise (",
  "os.admin.shop.wl_subtitle_after": ") est dérivée automatiquement du pays et n'est pas modifiable.",
  "os.admin.shop.wl_wallet": "Wallet",
  "os.admin.shop.wl_wallet_enabled": "Wallet activé",
  "os.admin.shop.wl_wallet_enabled_hint": "Le client peut utiliser un wallet dans cette boutique",
  "os.admin.shop.wl_recharge_enabled": "Recharge activée",
  "os.admin.shop.wl_recharge_hint": "Autoriser la recharge du wallet",
  "os.admin.shop.wl_max_balance": "Solde maximum ({currency})",
  "os.admin.shop.wl_max_balance_placeholder": "Illimité si vide",
  "os.admin.shop.wl_message": "Message wallet (optionnel)",
  "os.admin.shop.wl_message_placeholder": "Ex: Rechargez votre wallet en caisse",
  "os.admin.shop.wl_loyalty": "Fidélité",
  "os.admin.shop.wl_loyalty_enabled": "Fidélité activée",
  "os.admin.shop.wl_loyalty_hint": "Le client cumule des points dans cette boutique",
  "os.admin.shop.wl_ratio": "Ratio de points ({currency} pour 1 point)",
  "os.admin.shop.wl_ratio_placeholder_default": "Défaut pays : {ratio}",
  "os.admin.shop.wl_ratio_placeholder": "Ratio",
  "os.admin.shop.wl_ratio_hint": "Laisser vide pour utiliser le défaut du pays",
  "os.admin.shop.wl_ratio_hint_suffix": " ({ratio} {currency} / point)",
  "os.admin.shop.wl_points_name": "Nom des points (optionnel)",
  "os.admin.shop.wl_points_name_placeholder": "Ex: Kawas, Étoiles…",
  "os.admin.shop.wl_rewards_enabled": "Récompenses activées",
  "os.admin.shop.wl_rewards_hint": "Le client peut échanger ses points",
  "os.admin.shop.wl_save_btn": "Enregistrer Wallet & Fidélité",
  "os.admin.shop.wl_toast_load_error": "Impossible de charger la config Wallet & Fidélité",
  "os.admin.shop.wl_toast_saved": "Configuration Wallet & Fidélité enregistrée",
  "os.admin.shop.close_title": "Fermer définitivement cette boutique",
  "os.admin.shop.close_subtitle": "Action irréversible dans cette version : la boutique est archivée et ne peut plus être rouverte depuis l'application. Différent de la pause / fermeture du jour ci-dessus, qui reste réversible.",
  "os.admin.shop.close_btn": "Fermer définitivement cette boutique",
  "os.admin.shop.close_preview_error": "Impossible de charger les informations de fermeture",
  "os.admin.shop.close_modal_title": "Fermer définitivement {name} ?",
  "os.admin.shop.close_scope_notice": "Cette action concerne uniquement {name}. Les autres boutiques de votre entreprise resteront actives.",
  "os.admin.shop.close_wallet_label": "Solde Wallet Client",
  "os.admin.shop.close_active_orders_label": "Commandes en cours",
  "os.admin.shop.close_loyalty_label": "Points de fidélité",
  "os.admin.shop.close_loyalty_hint": "Information uniquement — n'empêche jamais la fermeture.",
  "os.admin.shop.close_affected_clients": "{count} client(s) concerné(s)",
  "os.admin.shop.close_blocked_intro": "La fermeture est bloquée tant que les points suivants ne sont pas résolus :",
  "os.admin.shop.close_confirm_btn": "Confirmer la fermeture",
  "os.admin.shop.close_success": "« {name} » a été fermée définitivement.",
  "os.admin.shop.close_already_archived": "Cette boutique est déjà fermée.",
  "os.admin.shop.close_blocked_error": "Fermeture impossible : préconditions non satisfaites.",
  "os.admin.shop.close_forbidden_error": "Vous n'êtes pas autorisé à fermer cette boutique.",
  "os.admin.shop.close_generic_error": "Erreur lors de la fermeture de la boutique",
  "os.admin.shop.close_billing_warning_title": "Boutique fermée — facturation à vérifier",
  "os.admin.shop.close_billing_warning_body": "La boutique est fermée, mais la mise à jour de la facturation n'a pas pu être confirmée. La boutique ne sera pas rouverte. La synchronisation de facturation devra être réessayée.",
  "os.admin.shop.close_billing_warning_ack": "J'ai compris",
  "os.admin.team.add_title": "Ajouter un barista",
  "os.admin.team.add_subtitle_before": "Crée un compte barista pour ",
  "os.admin.team.add_subtitle_after": ". Le barista accède uniquement au POS de cette boutique.",
  "os.admin.team.field_name": "Nom",
  "os.admin.team.field_username": "Identifiant",
  "os.admin.team.field_password": "Mot de passe",
  "os.admin.team.placeholder_name": "Ex: Sami Bensalem",
  "os.admin.team.placeholder_username": "Ex: Barista01",
  "os.admin.team.placeholder_password": "Mot de passe du barista",
  "os.admin.team.show": "Afficher",
  "os.admin.team.hide": "Masquer",
  "os.admin.team.create_btn": "Créer le barista",
  "os.admin.team.list_title": "Baristas de la boutique",
  "os.admin.team.list_empty": "Aucun barista pour cette boutique.",
  "os.admin.team.badge_barista": "Barista",
  "os.admin.team.active": "Actif",
  "os.admin.team.inactive": "Inactif",
  "os.admin.team.toast_load_error": "Impossible de charger l'équipe",
  "os.admin.team.toast_no_active_shop": "Aucune boutique active sélectionnée",
  "os.admin.team.toast_required": "Nom, identifiant et mot de passe sont requis",
  "os.admin.team.toast_created": "Barista créé",
  "os.admin.team.toast_create_error": "Erreur lors de la création du barista",
  "os.admin.team.reset_password_btn": "Réinitialiser le mot de passe",
  "os.admin.team.reset_password_title": "Nouveau mot de passe —",
  "os.admin.team.toast_reset_success": "Mot de passe réinitialisé",
  "os.admin.team.toast_reset_error": "Erreur lors de la réinitialisation du mot de passe",
  "os.admin.account.password_title": "Sécurité du compte",
  "os.admin.account.password_subtitle": "Changez le mot de passe de votre compte owner/staff.",
  "os.admin.account.toast_password_updated": "Mot de passe mis à jour",
  "os.admin.account.toast_password_error": "Erreur lors de la mise à jour du mot de passe",
  "os.admin.rewards.no_shop": "Sélectionnez une boutique pour gérer ses récompenses.",
  "os.admin.rewards.title": "Récompenses fidélité",
  "os.admin.rewards.subtitle_before": "Récompenses propres à ",
  "os.admin.rewards.add_btn": "Nouvelle récompense",
  "os.admin.rewards.empty_title": "Aucune récompense n'a encore été créée.",
  "os.admin.rewards.empty_desc": "Commencez par créer votre première récompense fidélité. Vous pourrez la modifier à tout moment.",
  "os.admin.rewards.empty_cta": "Créer une récompense",
  "os.admin.rewards.inactive_badge": "Inactive",
  "os.admin.rewards.pts": "pts",
  "os.admin.rewards.order_label": "ordre {order}",
  "os.admin.rewards.deactivate_title": "Désactiver",
  "os.admin.rewards.reactivate_title": "Réactiver",
  "os.admin.rewards.dialog_edit_title": "Modifier la récompense",
  "os.admin.rewards.dialog_new_title": "Nouvelle récompense",
  "os.admin.rewards.field_name": "Nom",
  "os.admin.rewards.field_name_placeholder": "Ex : Espresso offert",
  "os.admin.rewards.field_description": "Description",
  "os.admin.rewards.field_description_placeholder": "Description optionnelle",
  "os.admin.rewards.field_points": "Points requis",
  "os.admin.rewards.field_type": "Type",
  "os.admin.rewards.field_sort": "Ordre d'affichage",
  "os.admin.rewards.active_label": "Active",
  "os.admin.rewards.inactive_label": "Inactive",
  "os.admin.rewards.type_boisson": "Boisson",
  "os.admin.rewards.type_snack": "Snack",
  "os.admin.rewards.type_topping": "Topping",
  "os.admin.rewards.type_upgrade": "Upgrade",
  "os.admin.rewards.type_autre": "Autre",
  "os.admin.rewards.toast_load_error": "Impossible de charger les récompenses",
  "os.admin.rewards.toast_name_required": "Le nom est requis",
  "os.admin.rewards.toast_points_invalid": "Points requis : entier positif",
  "os.admin.rewards.toast_updated": "Récompense mise à jour",
  "os.admin.rewards.toast_created": "Récompense créée",
  "os.admin.rewards.toast_save_error": "Échec de l'enregistrement",
  "os.admin.rewards.toast_deactivated": "Récompense désactivée",
  "os.admin.rewards.toast_deactivate_error": "Échec de la désactivation",
  "os.admin.rewards.toast_reactivated": "Récompense réactivée",
  "os.admin.rewards.toast_reactivate_error": "Échec de la réactivation",
  "os.admin.stats.orders_by_status": "Commandes par statut",
  "os.admin.stats.orders_empty_title": "Aucune commande à afficher",
  "os.admin.stats.orders_empty_desc": "Les statuts de commande apparaîtront ici dès la première vente.",
  "os.admin.stats.revenue_by_payment": "Revenus par méthode de paiement",
  "os.admin.stats.revenue_empty_title": "Aucun revenu enregistré",
  "os.admin.stats.revenue_empty_desc": "La répartition par méthode de paiement s'affichera après vos premières ventes.",
  "os.admin.stats.pay_wallet": "Portefeuille",
  "os.admin.stats.pay_cash": "Espèces",
  "os.admin.stats.orders_count": "{count} commande(s)",
  "os.admin.stats.top_products": "Top 10 produits",
  "os.admin.stats.top_empty_title": "Aucun produit vendu",
  "os.admin.stats.top_empty_desc": "Votre classement des meilleures ventes apparaîtra ici.",
  "os.admin.stats.sold": "{count} vendus",
  "os.admin.closures.toast_load_error": "Impossible de charger les clôtures Z",
  "os.admin.closures.toast_select_shop": "Sélectionnez une boutique avant de clôturer.",
  "os.admin.closures.toast_period_required": "Renseignez une période (début et fin).",
  "os.admin.closures.toast_period_order": "La date de début doit être strictement antérieure à la date de fin.",
  "os.admin.closures.toast_idempotent": "Cette période est déjà clôturée (Z #{number}).",
  "os.admin.closures.toast_sealed": "Clôture Z #{number} scellée ({count} ticket(s)).",
  "os.admin.closures.err_forbidden": "Accès refusé à cette boutique.",
  "os.admin.closures.err_invalid_period": "Période invalide.",
  "os.admin.closures.err_failed": "Échec de la clôture.",
  "os.admin.closures.no_shop_title": "Sélectionnez une boutique",
  "os.admin.closures.no_shop_desc": "Choisissez une boutique pour gérer ses clôtures Z.",
  "os.admin.closures.title": "Clôtures Z (NF525)",
  "os.admin.closures.subtitle_before": "Clôtures scellées et chaînées de ",
  "os.admin.closures.create_btn": "Clôturer (Z)",
  "os.admin.closures.empty_title": "Aucune clôture Z pour cette boutique.",
  "os.admin.closures.empty_desc": "Créez une clôture Z pour sceller le chiffre d'affaires d'une période.",
  "os.admin.closures.integrity_ok": "Intègre",
  "os.admin.closures.integrity_altered": "Altérée",
  "os.admin.closures.row_meta": "{count} ticket(s) · scellée le {date}",
  "os.admin.closures.ttc": "TTC",
  "os.admin.closures.dialog_title": "Nouvelle clôture Z",
  "os.admin.closures.dialog_desc_before": "La clôture scelle le chiffre d'affaires de ",
  "os.admin.closures.dialog_desc_after": " sur la période choisie. Une période déjà clôturée n'est jamais recréée.",
  "os.admin.closures.field_start": "Début de période",
  "os.admin.closures.field_end": "Fin de période",
  "os.admin.closures.field_hint": "La fin est exclusive : pour clôturer une journée, choisissez le jour même en début et le lendemain en fin.",
  "os.admin.closures.archive_title": "Archives fiscales (NF525)",
  "os.admin.closures.dl_json": "Télécharger JSON",
  "os.admin.closures.dl_csv": "Télécharger CSV",
  "os.admin.closures.dl_pdf": "Télécharger PDF",
  "os.admin.closures.verify_btn": "Vérifier archive",
  "os.admin.closures.archive_version": "Version d'archive",
  "os.admin.closures.generated_at": "Générée le",
  "os.admin.closures.archive_hash": "Hash d'archive (SHA-256)",
  "os.admin.closures.archive_valid": "Archive valide",
  "os.admin.closures.archive_invalid": "Archive invalide",
  "os.admin.closures.v_hash": "Hash :",
  "os.admin.closures.v_signature": "Signature :",
  "os.admin.closures.v_closure": "Clôture :",
  "os.admin.closures.v_receipts": "Reçus :",
  "os.admin.closures.anomalies": "Anomalies détectées :",
  "os.admin.closures.toast_json_ok": "Archive JSON téléchargée.",
  "os.admin.closures.toast_json_error": "Échec du téléchargement de l'archive JSON.",
  "os.admin.closures.toast_csv_ok": "Export CSV téléchargé.",
  "os.admin.closures.toast_csv_error": "Échec du téléchargement du CSV.",
  "os.admin.closures.toast_pdf_ok": "Archive PDF téléchargée.",
  "os.admin.closures.toast_pdf_error": "Échec du téléchargement du PDF.",
  "os.admin.closures.toast_verify_ok": "Archive vérifiée : intègre et authentique.",
  "os.admin.closures.toast_verify_invalid": "Archive invalide : anomalies détectées.",
  "os.admin.closures.toast_verify_error": "Échec de la vérification de l'archive.",
  "os.admin.closures.detail_title": "Clôture Z #{number}",
  "os.admin.closures.d_number": "Numéro Z",
  "os.admin.closures.d_period_start": "Période (début)",
  "os.admin.closures.d_period_end": "Période (fin, exclue)",
  "os.admin.closures.d_tickets": "Tickets",
  "os.admin.closures.d_sealed": "Scellée le",
  "os.admin.closures.d_ttc": "Total TTC",
  "os.admin.closures.d_ht": "Total HT",
  "os.admin.closures.d_tva": "Total TVA",
  "os.admin.closures.d_refunds": "Remboursements",
  "os.admin.closures.d_net": "Net informatif",
  "os.admin.closures.pay_breakdown": "Ventilation par moyen de paiement",
  "os.admin.closures.no_data": "Aucune donnée.",
  "os.admin.closures.vat_breakdown": "Ventilation TVA",
  "os.admin.closures.vat_tickets": "{count} ticket(s)",
  "os.admin.closures.label_ht": "HT :",
  "os.admin.closures.label_tva": "TVA :",
  "os.admin.closures.crypto_seal": "Scellement cryptographique",
  "os.admin.closures.prev_z_hash": "Hash Z précédent",
  "os.admin.closures.integrity_anomalies": "Anomalies d'intégrité détectées",
  "os.admin.closures.pay_card": "Carte",
  "os.admin.closures.pay_cash": "Espèces",
  "os.admin.closures.pay_wallet": "Wallet",
  "os.admin.recipes.title": "Recettes SUPERKAWA",
  "os.admin.recipes.subtitle": "Catalogue central standardisé. Sélectionnez les recettes de votre boutique.",
  "os.admin.recipes.refresh": "Rafraîchir",
  "os.admin.recipes.selected_count_one": "{count} recette sélectionnée",
  "os.admin.recipes.selected_count_many": "{count} recettes sélectionnées",
  "os.admin.recipes.hint_select_shop": "— sélectionnez une boutique pour gérer la sélection",
  "os.admin.recipes.hint_readonly": "— lecture seule (réservé au propriétaire)",
  "os.admin.recipes.sync_btn": "Synchroniser les recettes sélectionnées",
  "os.admin.recipes.sync_title_dirty": "Enregistrez d'abord votre sélection",
  "os.admin.recipes.sync_title_default": "Crée les produits brouillon manquants",
  "os.admin.recipes.search_placeholder": "Rechercher une recette...",
  "os.admin.recipes.category_placeholder": "Catégorie",
  "os.admin.recipes.all_categories": "Toutes catégories",
  "os.admin.recipes.error": "Impossible de charger les recettes.",
  "os.admin.recipes.empty": "Aucune recette disponible pour l'instant.",
  "os.admin.recipes.no_result": "Aucune recette ne correspond à votre recherche.",
  "os.admin.recipes.section_drinks": "Boissons",
  "os.admin.recipes.section_food": "Cookies / Food",
  "os.admin.recipes.empty_drinks": "Aucune boisson dans cette sélection.",
  "os.admin.recipes.empty_food": "Aucune recette Cookies / Food pour l'instant.",
  "os.admin.recipes.ingredients": "Ingrédients",
  "os.admin.recipes.steps": "Étapes",
  "os.admin.recipes.tip": "Astuce",
  "os.admin.recipes.card_selected": "Sélectionnée",
  "os.admin.recipes.card_select": "Sélectionner",
  "os.admin.recipes.card_legacy": "Legacy — non sélectionnable",
  "os.admin.recipes.toast_sel_load_error": "Impossible de charger la sélection de la boutique",
  "os.admin.recipes.toast_sel_saved": "Sélection enregistrée",
  "os.admin.recipes.toast_sync_dirty": "Enregistrez d'abord votre sélection avant de synchroniser",
  "os.admin.recipes.toast_sync_empty": "Aucune recette sélectionnée à synchroniser",
  "os.admin.recipes.sync_added": "{count} ajouté(s) au menu",
  "os.admin.recipes.sync_updated": "{count} mis à jour",
  "os.admin.recipes.sync_hidden": "{count} masqué(s)",
  "os.admin.recipes.sync_nochange": "Aucun changement",
  "os.admin.recipes.toast_sync_summary": "{summary}. Produits visibles App + POS — définissez le prix dans Produits.",
  "os.admin.recipes.toast_sync_error": "Échec de la synchronisation",
  "os.admin.recipes.cat_cafe": "Café",
  "os.admin.recipes.cat_froid": "Froid",
  "os.admin.recipes.cat_cookies": "Cookies",
  "os.admin.recipes.cat_food": "Food",
  "os.admin.recipes.cat_patisserie": "Pâtisserie",
  "os.admin.recipes.cat_dessert": "Dessert",
  "os.admin.recipes.cat_snack": "Snack",
  "os.admin.recipes.cat_espresso_classiques": "Espresso & Classiques",
  "os.admin.recipes.cat_signatures": "Signatures",
  "os.admin.recipes.cat_africaines": "Africaines",
  "os.admin.recipes.cat_asiatiques": "Asiatiques",
  "os.admin.recipes.cat_iced_cold": "Iced & Cold",
  "os.admin.recipes.cat_saisonnieres": "Saisonnières",
  "os.admin.recipes.cat_sans_cafe": "Sans café & Mocktails",
  // MB-I18N-4 — Stock produit fini
  "os.admin.stock.status_ok": "OK",
  "os.admin.stock.status_low": "Stock bas",
  "os.admin.stock.status_out": "Rupture",
  "os.admin.stock.status_unknown": "Non initialisé",
  "os.admin.stock.title": "Stock",
  "os.admin.stock.tracked_count": "{count} produit(s) suivi(s)",
  "os.admin.stock.refresh": "Actualiser",
  "os.admin.stock.error_load": "Impossible de charger le stock de cette boutique.",
  "os.admin.stock.retry": "Réessayer",
  "os.admin.stock.alert_banner": "{count} produit(s) à réapprovisionner",
  "os.admin.stock.alert_rupture": "rupture",
  "os.admin.stock.enable_title": "Activer le suivi d'un produit",
  "os.admin.stock.select_placeholder": "Choisir un produit…",
  "os.admin.stock.select_all_tracked": "Tous les produits sont déjà suivis",
  "os.admin.stock.track_btn": "Suivre",
  "os.admin.stock.empty": "Aucun produit suivi pour l'instant.",
  "os.admin.stock.qty_placeholder": "Qté",
  "os.admin.stock.add": "Ajouter",
  "os.admin.stock.remove": "Retirer",
  "os.admin.stock.set": "Régler",
  "os.admin.stock.threshold": "Seuil",
  "os.admin.stock.history": "Historique",
  "os.admin.stock.untrack": "Ne plus suivre",
  "os.admin.stock.history_title": "Historique — {name}",
  "os.admin.stock.no_movement": "Aucun mouvement.",
  "os.admin.stock.toast_track_on": "Suivi de stock activé",
  "os.admin.stock.toast_track_off": "Suivi de stock désactivé",
  "os.admin.stock.toast_track_on_error": "Échec de l'activation du suivi",
  "os.admin.stock.toast_track_off_error": "Échec de la désactivation",
  "os.admin.stock.toast_qty_invalid": "Quantité invalide",
  "os.admin.stock.toast_updated": "Stock mis à jour",
  "os.admin.stock.toast_adjust_error": "Échec de l'ajustement",
  "os.admin.stock.toast_threshold_invalid": "Seuil invalide",
  "os.admin.stock.toast_threshold_saved": "Seuil enregistré",
  "os.admin.stock.toast_threshold_error": "Échec du seuil",
  "os.admin.stock.toast_history_error": "Échec du chargement de l'historique",
  // MB-I18N-4 — Onboarding coût matière
  "os.admin.cost_onboarding.step_done": "Terminé",
  "os.admin.cost_onboarding.step_todo": "À faire",
  "os.admin.cost_onboarding.title": "Démarrage du coût matière",
  "os.admin.cost_onboarding.subtitle": "Suivez ces 3 étapes pour obtenir votre première marge calculable.",
  "os.admin.cost_onboarding.step1_title": "Générer les ingrédients",
  "os.admin.cost_onboarding.step1_desc": "Créez votre catalogue depuis les standards.",
  "os.admin.cost_onboarding.step2_title": "Compléter les prix d'achat",
  "os.admin.cost_onboarding.step2_progress": "{priced} ingrédient(s) complété(s) / {total} ingrédient(s) totaux",
  "os.admin.cost_onboarding.step3_title": "Consulter les marges",
  "os.admin.cost_onboarding.step3_desc": "Au moins une recette calculable suffit pour valider.",
  "os.admin.cost_onboarding.cta_ingredients": "Aller aux Ingrédients",
  "os.admin.cost_onboarding.cta_material_cost": "Voir le Coût matière",
  "os.admin.cost_onboarding.cta_margins": "Voir les Marges",
  // MB-I18N-4 — Unités
  "os.admin.units.piece": "pièce",
  "os.admin.units.portion": "portion",
  "os.admin.units.shot": "shot",
  "os.admin.units.spoon": "cuillère",
  // MB-I18N-4 — Ingrédients
  "os.admin.ingredients.std_linked": "Relié",
  "os.admin.ingredients.std_suggestion": "Suggestion disponible",
  "os.admin.ingredients.std_unknown": "Non reconnu",
  "os.admin.ingredients.error_load": "Impossible de charger les ingrédients de cette boutique.",
  "os.admin.ingredients.retry": "Réessayer",
  "os.admin.ingredients.title": "Ingrédients",
  "os.admin.ingredients.count": "{count} ingrédient(s) · catalogue par boutique",
  "os.admin.ingredients.generate_btn": "Générer les ingrédients depuis les standards",
  "os.admin.ingredients.autodetect_btn": "Auto-détecter les standards",
  "os.admin.ingredients.add_btn": "Ajouter un ingrédient",
  "os.admin.ingredients.coverage_standards": "Standards couverts",
  "os.admin.ingredients.coverage_ingredients": "Ingrédients reliés",
  "os.admin.ingredients.coverage_reliability": "Fiabilité coût matière",
  "os.admin.ingredients.coverage_reliability_hint": "couverture globale des recettes",
  "os.admin.ingredients.missing_standards": "Standards non reliés ({count})",
  "os.admin.ingredients.copy_missing": "Copier les standards manquants",
  "os.admin.ingredients.search_placeholder": "Rechercher un ingrédient…",
  "os.admin.ingredients.show_inactive": "Afficher les inactifs",
  "os.admin.ingredients.empty": "Aucun ingrédient pour l'instant. Ajoutez votre premier ingrédient.",
  "os.admin.ingredients.inactive": "Inactif",
  "os.admin.ingredients.supplier_label": "Fournisseur : {name}",
  "os.admin.ingredients.link_apply": "Appliquer",
  "os.admin.ingredients.link_manual": "Relier manuellement",
  "os.admin.ingredients.price_pending": "Prix à compléter",
  "os.admin.ingredients.per_unit": "par {unit}",
  "os.admin.ingredients.edit": "Modifier",
  "os.admin.ingredients.deactivate": "Désactiver",
  "os.admin.ingredients.reactivate": "Réactiver",
  "os.admin.ingredients.dialog_edit_title": "Modifier l'ingrédient",
  "os.admin.ingredients.dialog_new_title": "Nouvel ingrédient",
  "os.admin.ingredients.field_name": "Nom",
  "os.admin.ingredients.field_name_placeholder": "ex. Lait entier",
  "os.admin.ingredients.field_base_unit": "Unité de référence",
  "os.admin.ingredients.field_unit_cost": "Coût unitaire ({currency}/{unit})",
  "os.admin.ingredients.field_unit_cost_placeholder": "ex. 0.0018",
  "os.admin.ingredients.field_standard": "Standard (coût matière)",
  "os.admin.ingredients.standard_none_placeholder": "Aucun",
  "os.admin.ingredients.standard_none": "Aucun (non relié)",
  "os.admin.ingredients.standard_hint": "Relie cet ingrédient à un standard Coffee-Only pour le calcul du coût matière.",
  "os.admin.ingredients.field_supplier": "Fournisseur (optionnel)",
  "os.admin.ingredients.field_supplier_placeholder": "ex. Laiterie locale",
  "os.admin.ingredients.cancel": "Annuler",
  "os.admin.ingredients.save": "Enregistrer",
  "os.admin.ingredients.autodetect_title": "Auto-détection des standards",
  "os.admin.ingredients.autodetect_desc": "Suggestions basées sur les alias des standards Coffee-Only. Décochez celles que vous ne souhaitez pas appliquer. Rien n'est appliqué sans votre validation.",
  "os.admin.ingredients.match_exact": "exact",
  "os.admin.ingredients.match_alias": "alias",
  "os.admin.ingredients.autodetect_empty": "Aucune suggestion disponible.",
  "os.admin.ingredients.autodetect_apply": "Appliquer la sélection ({count})",
  "os.admin.ingredients.generate_title": "Générer les ingrédients depuis les standards",
  "os.admin.ingredients.generate_report_a": "ingrédient(s) généré(s) avec un coût à 0 (",
  "os.admin.ingredients.generate_report_b": "). Aucun prix n'a été inventé : renseignez vos coûts d'achat réels pour chaque ingrédient.",
  "os.admin.ingredients.generate_price_pending": "prix à compléter",
  "os.admin.ingredients.generate_preview_a": "ingrédient(s) seront créés avec",
  "os.admin.ingredients.generate_preview_b": "et un statut",
  "os.admin.ingredients.generate_preview_status": "« Prix à compléter »",
  "os.admin.ingredients.generate_preview_c": ". Les sous-recettes sont exclues.",
  "os.admin.ingredients.generate_preview_d": "Aucun prix n'est inventé : vous devrez saisir vos coûts d'achat réels après génération.",
  "os.admin.ingredients.generate_nothing": "Tous les standards requis sont déjà reliés. Rien à générer.",
  "os.admin.ingredients.generate_already_linked": "Déjà reliés : {count}",
  "os.admin.ingredients.generate_sub_recipes": "Sous-recettes exclues : {list}",
  "os.admin.ingredients.generate_name_clash": "Conflits de nom ignorés : {count}",
  "os.admin.ingredients.generate_confirm_label": "Pour confirmer, saisissez exactement :",
  "os.admin.ingredients.generate_close": "Fermer",
  "os.admin.ingredients.generate_apply": "Générer {count} ingrédient(s)",
  "os.admin.ingredients.generate_0_todo": "0 à compléter",
  "os.admin.ingredients.toast_name_required": "Le nom est requis",
  "os.admin.ingredients.toast_cost_invalid": "Coût unitaire invalide (≥ 0)",
  "os.admin.ingredients.toast_updated": "Ingrédient mis à jour",
  "os.admin.ingredients.toast_added": "Ingrédient ajouté",
  "os.admin.ingredients.toast_save_error": "Échec de l'enregistrement",
  "os.admin.ingredients.toast_deactivated": "Ingrédient désactivé",
  "os.admin.ingredients.toast_reactivated": "Ingrédient réactivé",
  "os.admin.ingredients.toast_toggle_error": "Échec",
  "os.admin.ingredients.toast_linked": "« {name} » relié à {standard}",
  "os.admin.ingredients.toast_link_error": "Échec de la liaison",
  "os.admin.ingredients.toast_none_selected": "Aucune suggestion sélectionnée",
  "os.admin.ingredients.toast_linked_multi": "{ok} ingrédient(s) relié(s)",
  "os.admin.ingredients.toast_linked_multi_fail": "{ok} ingrédient(s) relié(s), {fail} échec(s)",
  "os.admin.ingredients.toast_none_applied": "Aucune liaison appliquée",
  "os.admin.ingredients.toast_preview_error": "Échec du chargement de l'aperçu",
  "os.admin.ingredients.toast_confirm_exact": "Saisissez exactement « GEN-INGREDIENTS » pour confirmer.",
  "os.admin.ingredients.toast_generated": "{count} ingrédient(s) généré(s) · prix à compléter",
  "os.admin.ingredients.toast_generate_error": "Échec de la génération",
  "os.admin.ingredients.toast_copy_ok": "Liste copiée",
  "os.admin.ingredients.toast_copy_error": "Impossible de copier la liste",
  // MB-I18N-4 — Coût matière
  "os.admin.material_cost.status_ok": "OK",
  "os.admin.material_cost.status_missing": "À chiffrer",
  "os.admin.material_cost.status_unit_mismatch": "Unité incompatible",
  "os.admin.material_cost.status_price_pending": "Prix à compléter",
  "os.admin.material_cost.loading": "Chargement du coût matière…",
  "os.admin.material_cost.error": "Erreur de chargement du coût matière.",
  "os.admin.material_cost.title": "Coût matière",
  "os.admin.material_cost.subtitle": "Coût matière calculé à partir des recettes de l'établissement et des coûts ingrédients de la boutique.",
  "os.admin.material_cost.summary_recipes": "Recettes analysées",
  "os.admin.material_cost.summary_computable": "Entièrement chiffrées",
  "os.admin.material_cost.summary_coverage": "Couverture globale",
  "os.admin.material_cost.empty": "Aucune recette à afficher. Renseignez les coûts dans l'onglet Ingrédients.",
  "os.admin.material_cost.partial": "partiel",
  "os.admin.material_cost.col_ingredient": "Ingrédient",
  "os.admin.material_cost.col_qty": "Quantité",
  "os.admin.material_cost.col_cost": "Coût",
  "os.admin.material_cost.col_status": "Statut",
  "os.admin.material_cost.missing_count": "{count} ingrédient(s) à chiffrer",
  "os.admin.material_cost.cta_ingredients": "Renseigner dans Ingrédients",
  "os.admin.material_cost.optional_excluded": "Optionnels (exclus du coût) :",
  "os.admin.material_cost.zero_cost": "Inclus sans coût :",
  "os.admin.material_cost.currency_warning": "Plusieurs devises détectées : {list}",
  // MB-I18N-4 — Marges
  "os.admin.margins.error_load": "Impossible de charger les marges de cette boutique.",
  "os.admin.margins.retry": "Réessayer",
  "os.admin.margins.title": "Marges",
  "os.admin.margins.subtitle": "Marge brute matière = prix de vente − coût matière (hors main-d'œuvre, charges, TVA).",
  "os.admin.margins.summary_calculable": "Produits calculables",
  "os.admin.margins.summary_margin": "Taux de marge moyen",
  "os.admin.margins.summary_foodcost": "Food cost moyen",
  "os.admin.margins.empty": "Aucun produit relié à une recette pour cette boutique.",
  "os.admin.margins.empty_cta": "Aller aux Produits",
  "os.admin.margins.top": "Top marges",
  "os.admin.margins.low": "Marges faibles",
  "os.admin.margins.noncalc": "Produits non calculables ({count})",
  "os.admin.margins.metric_sale_price": "Prix de vente",
  "os.admin.margins.metric_material_cost": "Coût matière",
  "os.admin.margins.metric_gross_margin": "Marge brute matière",
  "os.admin.margins.metric_margin_rate": "Taux de marge",
  "os.admin.margins.metric_food_cost": "Food cost",
  "os.admin.margins.metric_multiplier": "Multiplicateur",
  "os.admin.margins.cta_set_price": "Définir un prix",
  "os.admin.margins.cta_ingredients": "Renseigner les ingrédients",
  "os.admin.margins.cta_material_cost": "Voir le coût matière",
  "os.admin.margins.cta_check_ingredients": "Vérifier les ingrédients",
  "os.admin.margins.reasons.no_price": "Prix de vente absent",
  "os.admin.margins.reasons.cost_incomplete": "Coût matière incomplet",
  "os.admin.margins.reasons.no_recipe_cost": "Recette non chiffrable",
  "os.admin.margins.reasons.currency_mismatch": "Devises ingrédients mélangées",
  "os.admin.margins.reasons.unknown": "Non calculable",
  // MB-I18N-4 — Inventaire matière
  "os.admin.inventory.status_ok": "OK",
  "os.admin.inventory.status_low": "Faible",
  "os.admin.inventory.status_out": "Rupture",
  "os.admin.inventory.status_unknown": "Non initialisé",
  "os.admin.inventory.status_non_suivi": "Non suivi",
  "os.admin.inventory.mv_sale": "Vente",
  "os.admin.inventory.mv_restock": "Réception",
  "os.admin.inventory.mv_loss": "Perte/Casse",
  "os.admin.inventory.mv_adjust": "Ajustement",
  "os.admin.inventory.mv_inventory": "Inventaire",
  "os.admin.inventory.error_load": "Impossible de charger l'inventaire matière de cette boutique.",
  "os.admin.inventory.retry": "Réessayer",
  "os.admin.inventory.header_title": "Inventaire matière",
  "os.admin.inventory.header_subtitle": "Suivi du stock des ingrédients (matière première). Le stock se décrémente automatiquement à la complétion des commandes.",
  "os.admin.inventory.empty": "Aucun ingrédient dans cette boutique. Ajoutez vos ingrédients pour suivre le stock matière.",
  "os.admin.inventory.empty_cta": "Gérer les ingrédients",
  "os.admin.inventory.kpi_tracked": "Ingrédients suivis",
  "os.admin.inventory.kpi_low": "Alertes faibles",
  "os.admin.inventory.kpi_out": "Ruptures",
  "os.admin.inventory.kpi_mv7": "Mouvements 7 j",
  "os.admin.inventory.none_tracked": "Aucun ingrédient suivi pour le moment. Activez le suivi sur un ingrédient ci-dessous pour démarrer.",
  "os.admin.inventory.alerts_title": "À réapprovisionner ({count})",
  "os.admin.inventory.col_ingredient": "Ingrédient",
  "os.admin.inventory.col_standard": "Standard",
  "os.admin.inventory.col_stock": "Stock",
  "os.admin.inventory.col_unit": "Unité",
  "os.admin.inventory.col_threshold": "Seuil",
  "os.admin.inventory.col_status": "Statut",
  "os.admin.inventory.col_actions": "Actions",
  "os.admin.inventory.restock": "Réception",
  "os.admin.inventory.loss": "Perte",
  "os.admin.inventory.inventory": "Inventaire",
  "os.admin.inventory.track_activate": "Activer le suivi",
  "os.admin.inventory.dialog_restock": "Réception fournisseur",
  "os.admin.inventory.dialog_loss": "Perte / casse",
  "os.admin.inventory.dialog_inventory": "Inventaire physique",
  "os.admin.inventory.field_physical_stock": "Stock physique constaté ({unit})",
  "os.admin.inventory.field_qty": "Quantité ({unit})",
  "os.admin.inventory.placeholder_inventory": "Ex. 4500",
  "os.admin.inventory.placeholder_qty": "Ex. 1000",
  "os.admin.inventory.current_stock": "Stock actuel : {qty} {unit}",
  "os.admin.inventory.reason": "Motif",
  "os.admin.inventory.reason_optional": "(optionnel)",
  "os.admin.inventory.placeholder_reason_loss": "Ex. casse, péremption",
  "os.admin.inventory.placeholder_reason_inventory": "Ex. inventaire mensuel",
  "os.admin.inventory.placeholder_reason_restock": "Ex. livraison fournisseur",
  "os.admin.inventory.cancel": "Annuler",
  "os.admin.inventory.validate": "Valider",
  "os.admin.inventory.track_dialog_title": "Suivi du stock — {name}",
  "os.admin.inventory.field_initial_stock": "Stock initial ({unit})",
  "os.admin.inventory.field_threshold": "Seuil d'alerte ({unit})",
  "os.admin.inventory.placeholder_initial": "Ex. 5000",
  "os.admin.inventory.placeholder_threshold": "Ex. 1000",
  "os.admin.inventory.untrack": "Ne plus suivre",
  "os.admin.inventory.save": "Enregistrer",
  "os.admin.inventory.toast_qty_invalid": "Quantité invalide",
  "os.admin.inventory.toast_reason_required": "Motif obligatoire",
  "os.admin.inventory.toast_updated": "Stock mis à jour",
  "os.admin.inventory.toast_update_error": "Échec de la mise à jour",
  "os.admin.inventory.toast_track_on": "Suivi activé",
  "os.admin.inventory.toast_track_off": "Suivi désactivé",
  "os.admin.inventory.history_title": "Historique — {name}",
  "os.admin.inventory.history_empty": "Aucun mouvement enregistré.",
  "os.admin.inventory.hist_col_date": "Date",
  "os.admin.inventory.hist_col_type": "Type",
  "os.admin.inventory.hist_col_qty": "Quantité",
  "os.admin.inventory.hist_col_stock_after": "Stock après",
  "os.admin.inventory.hist_col_reason": "Motif",
};
